import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import AnnouncementBanner from "./AnnouncementBanner";

const SIDEBAR_STORAGE_KEY = "rmc2.sidebar.collapsed";
const getInitialCollapsed = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return localStorage.getItem(SIDEBAR_STORAGE_KEY) === "true";
};

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    getInitialCollapsed
  );

  useEffect(() => {
    localStorage.setItem(SIDEBAR_STORAGE_KEY, String(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  return (
    <div className="app-shell">
      <AnnouncementBanner />
      <Header onMenuClick={() => setIsSidebarOpen(true)} />
      <div className="flex min-h-[calc(100vh-72px)]">
        <Sidebar
          isOpen={isSidebarOpen}
          isCollapsed={isSidebarCollapsed}
          onClose={() => setIsSidebarOpen(false)}
          onToggleCollapse={() => setIsSidebarCollapsed((prev) => !prev)}
        />
        <main className="relative flex-1 px-6 pb-10 pt-8 lg:px-10">
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;
